<template>
    <div class="main">
        <div class="grid-container">
            <div class="brand-image">
                <img :src="brands[0].hero_image_url" />
            </div>
            <div class="grid-x grid-margin-x" v-if="sneakers != null">
                <div v-for="sneaker in sneakers" class="small-12 medium-6 large-4 cell">
                    <router-link :to="{ path: `/sneakers/${sneaker.brand}/${sneaker.slug}` }" class="card">
                        <img :src="sneaker.image_url" />
                        <div class="card-section">
                            <p class="lead">{{ sneaker.brand }}</p>
                            <p>{{ sneaker.model_name }}</p>
                            <div class="grid-x card-info">
                                <div class="small-5 small-offset-1">
                                    <p>{{ sneaker.release_date_pretty }}</p>
                                </div>
                                <div class="small-5 small-offset-1">
                                    <p v-if="sneaker.original_price != 'TBA'">€{{ sneaker.original_price }}</p>
                                    <p v-else>{{ sneaker.original_price }}</p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="small-12 cell text-center">
                    <button class="button" v-on:click="loadMoreSneakers()">Load more sneakers</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'brand',
    props: ['brand'],
    data () {
        return {
            loadedSneakersCount: 12
        }
    },
    computed: {
        brands () {
            return this.$store.getters.loadedBrands.filter(brand => brand.name === this.brand)
        },
        sneakers () {
            return this.$store.getters.loadedBrand(this.brand).slice(0, this.loadedSneakersCount)
        }
    },
    methods: {
        loadMoreSneakers: function () {
            this.loadedSneakersCount += 12
        }
    }
}
</script>
<style>
.vue-simple-spinner {
    margin: 35vh auto 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// Brand.vue?037ece8b